import { createReducer } from "redux-act";

import * as a from "../actions/ide";

const getDefaultState = () => ({
  currentRepository: null,
  isCommiting: false,
  isLoading: false,
  currentProject: null,
  activeCommitId: null,
  isLoadingRepositories: false,
  isCommitingSuccess: null,
  userRepositoryLoaded: false,
  isCommitLoadingSuccess: null,
  isLoadingProjectTemplate: false,
  projectTemplateData: null,
  projectTemplateLoadingError: null,
  isCurrentProjectError: null,
  ideProjectStarterCodeContent: null,
  isLoadingIdeProjectStarterCode: false,
  ideProjectStarterCodeLoadingError: null,
});

export default () =>
  createReducer(
    {
      [a.createTextJamCommit]: (state) => {
        return {
          ...state,
          isCommiting: true,
          isCommitingSuccess: null,
        };
      },
      [a.addCommit]: (state) => {
        return {
          ...state,
          isCommiting: true,
          isCommitingSuccess: null,
        };
      },
      [a.addCommitError]: (state) => ({
        ...state,
        isCommiting: false,
        isCommitingSuccess: false,
      }),
      [a.receivedResponseOnCommit]: (state, payload) => {
        const { repository, commit, currentProject } = payload;
        const previousCommits = state.currentRepository && state.currentRepository?.id === repository.id
            ? state.currentRepository.commits || []
            : [];

        const mergedCommits = [...previousCommits];
        if (commit?.id && !mergedCommits.some((c) => c.id === commit.id)) {
          mergedCommits.unshift(commit);
        }

        const repositoryWithCommits = {
          ...repository,
          commits: mergedCommits,
        };

        return {
          ...state,
          isCommiting: false,
          isCommitingSuccess: true,
          activeCommitId: commit?.id ?? state.activeCommitId,
          currentRepository: repositoryWithCommits,
          currentProject: currentProject ?? state.currentProject,
        };
      },
      [a.getProjectByCommit]: (state) => {
        return {
          ...state,
          isLoading: true,
          isCommitLoadingSuccess: null,
        };
      },
      [a.loadProjectByCommitError]: (state) => {
        return {
          ...state,
          isLoading: false,
          isCommitLoadingSuccess: false,
          isCurrentProjectError: true,
        };
      },
      [a.receivedProjectByCommit]: (state, payload) => {
        const { commitId, project } = payload;
        return {
          ...state,
          currentProject: project,
          activeCommitId: commitId,
          isCommitLoadingSuccess: true,
          isLoading: false,
          userRepositoryLoaded: true,
          isCurrentProjectError: false,
        };
      },
      [a.clearCurrentProject]: (state) => {
        return {
          ...state,
          currentProject: null,
        };
      },
      [a.getMyRepository]: (state) => {
        return {
          ...state,
          isLoadingRepositories: true,
          userRepositoryLoaded: false,
        };
      },
      [a.receivedMyRepository]: (state, payload) => {
        const { repository } = payload;
        return {
          ...state,
          currentRepository: repository,
          activeCommitId: repository?.commits?.[0]?.id ?? null,
          isLoadingRepositories: false,
          userRepositoryLoaded: true,
        };
      },
      [a.getMyRepositoryError]: (state) => ({
        ...state,
        isLoadingRepositories: false,
      }),
      [a.setActiveCommit]: (state, payload) => {
        const { commitId } = payload;
        return {
          ...state,
          activeCommitId: commitId,
        };
      },

      [a.getProjectByRepository]: (state) => {
        return {
          ...state,
          isLoading: true,
        };
      },
      [a.receivedProjectByRepository]: (state, payload) => {
        const { project } = payload;
        return {
          ...state,
          currentProject: project,
          isLoading: false,
          isCurrentProjectError: false,
        };
      },
      [a.getProjectByRepositoryError]: (state) => {
        return {
          ...state,
          isLoading: false,
          isCurrentProjectError: true,
        };
      },
      [a.getRepository]: (state) => {
        return {
          ...state,
          isLoadingRepositories: true,
          userRepositoryLoaded: false,
        };
      },
      [a.receivedRepository]: (state, payload) => {
        const { repository } = payload;
        return {
          ...state,
          currentRepository: repository,
          isLoadingRepositories: false,
          userRepositoryLoaded: true,
        };
      },
      [a.getRepositoryError]: (state) => ({
        ...state,
        isLoadingRepositories: false,
        userRepositoryLoaded: true,
      }),
      [a.getTextJamTemplate]: (state) => {
        return {
          ...state,
          isLoadingProjectTemplate: true,
          projectTemplateData: null,
          projectTemplateLoadingError: null,
        };
      },
      [a.receivedTextJamTemplate]: (state, payload) => {
        return {
          ...state,
          isLoadingProjectTemplate: false,
          projectTemplateData: payload.template,
          projectTemplateLoadingError: null,
        };
      },
      [a.getTextJamTemplateError]: (state) => ({
        ...state,
          isLoadingProjectTemplate: false,
          projectTemplateData: null,
          projectTemplateLoadingError: true,
      }),
      [a.getIdeProjectStarterCode]: (state) => ({
        ...state,
        isLoadingIdeProjectStarterCode: true,
        ideProjectStarterCodeContent: null,
        ideProjectStarterCodeLoadingError: null,
      }),
      [a.receivedIdeProjectStarterCode]: (state, payload) => ({
        ...state,
        isLoadingIdeProjectStarterCode: false,
        ideProjectStarterCodeContent: payload.content,
        ideProjectStarterCodeLoadingError: null,
      }),
      [a.getIdeProjectStarterCodeError]: (state) => ({
        ...state,
        isLoadingIdeProjectStarterCode: false,
        ideProjectStarterCodeContent: null,
        ideProjectStarterCodeLoadingError: true,
      }),
      [a.clearIdeProjectStarterCode]: (state) => ({
        ...state,
        ideProjectStarterCodeContent: null,
        isLoadingIdeProjectStarterCode: false,
        ideProjectStarterCodeLoadingError: null,
      }),
      [a.resetIdeState]: () => getDefaultState(),
    },
    getDefaultState(),
  );
